//
//
//
//

export default {
  name: 'DownloadApp',
  data () {
    return { }
  },
  methods: {
    goToDownload () {
      // this.$router.push()
      location.href = "http://www.xcz.im"
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/music_player/DownloadApp.vue